// extracted by mini-css-extract-plugin
export default {"stamp":"RatingStamp_stamp__wcpz2","value":"RatingStamp_value__+DyNP","max":"RatingStamp_max__1IQLL"};